var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Accessor_1 = require("./Accessor");

var CustomHighlightAccessor = function (_super) {
  __extends(CustomHighlightAccessor, _super);

  function CustomHighlightAccessor(request) {
    var _this = _super.call(this) || this;

    _this.request = request;
    _this.highlightRequest = request;
    return _this;
  }

  CustomHighlightAccessor.prototype.buildOwnQuery = function (query) {
    return query.setHighlight(this.highlightRequest);
  };

  return CustomHighlightAccessor;
}(Accessor_1.Accessor);

exports.CustomHighlightAccessor = CustomHighlightAccessor;